/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Font_Family_Aria_LabelInputs */

const en_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Family Selection`)
};

const fr_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection de police`)
};

const de_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfamilienauswahl`)
};

const it_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione della famiglia di caratteri`)
};

const ru_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор семейства шрифтов`)
};

const es_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de la familia de fuentes`)
};

const zh_cn2_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体系列选择`)
};

const ja_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントファミリーの選択`)
};

const hi_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट परिवार का चयन`)
};

const pt_pt2_styles_font_family_aria_label = /** @type {(inputs: Styles_Font_Family_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de Família de Fontes`)
};

/**
* | output |
* | --- |
* | "Font Family Selection" |
*
* @param {Styles_Font_Family_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_font_family_aria_label = /** @type {((inputs?: Styles_Font_Family_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Font_Family_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_font_family_aria_label(inputs)
	if (locale === "de") return de_styles_font_family_aria_label(inputs)
	if (locale === "it") return it_styles_font_family_aria_label(inputs)
	if (locale === "ru") return ru_styles_font_family_aria_label(inputs)
	if (locale === "es") return es_styles_font_family_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_font_family_aria_label(inputs)
	if (locale === "ja") return ja_styles_font_family_aria_label(inputs)
	if (locale === "hi") return hi_styles_font_family_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_font_family_aria_label(inputs)
	return en_styles_font_family_aria_label(inputs)
});